import styled from 'styled-components';

export const SelectedPlanContainer = styled.div`
  background: ${({ theme }) => theme.colors.lightBlue};
  padding: 20px 24px;
  border-radius: 15px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-top: 21px;

  span {
    font-weight: 700;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }
`;

export const PlanInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  span {
    font-weight: 500;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }

  .timeFrame {
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }
`;

export const PlanPriceContainer = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-weight: 400;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.darkBlue2};
    line-height: 13px;
    text-align: right;
  }

  .highlightedText {
    font-weight: 600;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.darkBlue2};
    line-height: 13px;
    text-align: right;
  }
`;

export const PriceContainer = styled.div`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.darkBlue2};
  background: ${({ theme }) => theme.colors.white};
  margin-bottom: 4px;

  span {
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }

  .smallText {
    font-size: 10px;
  }
`;

export const InstructionsContainer = styled.div`
  margin-top: 56px;

  h1 {
    font-weight: 600;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey};
    margin-bottom: 31px;
  }

  div span {
    font-weight: 500;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey1};
  }

  .middleText {
    margin: 20px 0;
  }

  .highlighted {
    font-weight: 700;
  }
`;

export const PaymentMethodContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin: 65px 0 23px 0;
`;

export const SelectedPaymentMethod = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 13px;

  span {
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.grey};
  }

  img {
    width: 19px;
    height: 19px;
  }
`;

export const ChangeMethodContainer = styled.div`
  cursor: pointer;

  span {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
  }
`;

export const PixWrapper = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.darkBlue2};
  border-radius: 15px;
`;

export const PixKeyWrapper = styled.div`
  padding: 26px 30px 14px;

  display: flex;
  flex-direction: column;
  gap: 8px;

  > span {
    font-weight: 500;
    font-size: 16px;
    color: #4e4b59;
  }
`;

export const PixTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 11px;
`;

export const PixCodeContainer = styled.div`
  display: flex;
  flex-direction: row;
  algin-items: center;
  justify-content: space-between;
  gap: 11px;
  width: 100%;

  > div {
    max-width: 80%;
  }

  div span {
    font-weight: 400;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.primary};
    overflow-wrap: break-word;
  }
`;

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  cursor: pointer;

  div {
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 999px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 38px;
    height: 38px;
  }

  div svg {
    color: ${({ theme }) => theme.colors.white};
  }

  > span {
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const PixQRCodeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  border-top: 1px solid ${({ theme }) => theme.colors.darkBlue2};

  gap: 35px;

  padding: 22px 30px 26px;
`;

export const QRCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 8px;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 13px;

    img {
      color: #686574;
      width: 16px;
      height: 16px;
    }
  }

  > img {
    color: #165b83;
    width: 100px;
    height: 100px;
  }
`;

export const TimerContainer = styled.div`
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 25px;

  border: 1px solid ${({ theme }) => theme.colors.darkBlue2};

  border-radius: 8px;

  span {
    font-weight: 700;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }

  .lightTimerText {
    font-weight: 500;
  }
`;
